/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, get, isEmpty, sumBy } from "lodash";
import React, { useEffect, useState } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { CardHeader, CardTitle, CardUnit } from "../../../components/ContentLayout";
import Loading from "../../../components/Loading";
import NoData from "../../../components/NoData/NoData";
import { dateToFormat, dateToViewFormat, getMonthRange } from "../../../utils/date";
import { getFinancesStatistics } from "../../../utils/financesStatistics";
import { comma } from "../../../utils/number";
import { classnames } from "../../../utils/text";

const MonthlyProfitLossChart = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [monthDate, setMonthDate] = useState({})
  const [monthMargin, setMonthMargin] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null)
  const [options, setOptions] = useState(null)

  const tabList = [
    { label: "세금계산서", action: setActiveTab },
    { label: "거래명세서", action: setActiveTab },
  ];

  const getPreMonth = () => {
    setMonthMargin(monthMargin + 1)
  }
  const getNextMonth = () => {
    setMonthMargin(monthMargin - 1)
  }

  useEffect(() => {
    setMonthDate(getMonthRange(monthMargin, true))
  }, [monthMargin])

  useEffect(() => {
    if (!isEmpty(monthDate)) {
      const _params = {
        groupBy: "month",
        startAt: monthDate.from,
        endAt: monthDate.to
      }
      submit(_params)
    }
  }, [monthDate, activeTab])

  const submit = async (params) => {
    setIsLoading(true)

    const {
      invoiceSales,
      invoicePurchase,
      taxPurchase,
      taxSales,
      cardPurchase,
      cardSales,
      cashReceiptsPurchase,
      cashReceiptsSales,
      salaryHistories
    } = await getFinancesStatistics(params)

    if (
      isEmpty(invoiceSales) &&
      isEmpty(invoicePurchase) &&
      isEmpty(taxPurchase) &&
      isEmpty(taxSales) &&
      isEmpty(cardPurchase) &&
      isEmpty(cardSales) &&
      isEmpty(cashReceiptsPurchase) &&
      isEmpty(cashReceiptsSales) &&
      isEmpty(salaryHistories)
    ) {
      setData({})
      setIsLoading(false)
      return
    }

    const month = new Date(monthDate.from).getMonth() + 1;
    let salesAmt = 0
    let purchaseAmt = 0
    const findTaxPurchase = taxPurchase.find(item => item.month === month)
    const findTaxSales = taxSales.find(item => item.month === month)
    const findCardPurchase = cardPurchase.filter(item => item.month === month) // 카드 매입
    const findCashReceiptsPurchase = cashReceiptsPurchase.find(item => item.month === month)
    const findCashReceiptsSales = cashReceiptsSales.find(item => item.month === month)
    const findCardSales = cardSales.find(item => item.month === month) //카드 매출

    if (activeTab === 0) {
      salesAmt = get(findTaxSales, 'totalAmt', 0)
      purchaseAmt = get(findTaxPurchase, 'totalAmt', 0)
    } else {
      salesAmt = sumBy(invoiceSales, 'totalAmt') || 0
      purchaseAmt = sumBy(invoicePurchase, 'totalAmt') || 0
    }

    let cardPurchaseAmt = 0
    forEach(findCardPurchase, purchase => {
      cardPurchaseAmt += purchase.useAmt
    })

    // 매출
    const salesTotals = Math.round(salesAmt / 1000)
    // 매입
    const purchaseTotals = Math.round(purchaseAmt / 1000)
    // 신용카드 매출
    const cardSalesTotal = Math.round(get(findCardSales, 'payAmt', 0) / 1000)
    // 신용카드 매입
    const cardPurchaseTotal = Math.round(cardPurchaseAmt / 1000)
    // 현금영수증 매출
    const cashReceiptsSalesTotal = Math.round(get(findCashReceiptsSales, 'totAmt', 0) / 1000)
    // 현금영수증 매입
    const cashReceiptsPurchaseTotal = Math.round(get(findCashReceiptsPurchase, 'totAmt', 0) / 1000)
    // 인건비
    const salaryHistoriesTotal = Math.round(get(salaryHistories.find(item => item.month === month), 'paymentByDifference', 0) / 1000)
    // 월별 손익 (매출(계산서) + 카드매출 + - 매입(계산서) - 카드매입 - 인건비)
    const monthlyProfitLossTotal = salesTotals + cardSalesTotal + cashReceiptsSalesTotal - purchaseTotals - cardPurchaseTotal - cashReceiptsPurchaseTotal - salaryHistoriesTotal

    setData({
      labels: ['매출', '매입', '신용카드 매출', '신용카드 매입', '현금영수증 매출', '현금영수증 매입', '인건비', `${dateToFormat(monthDate.from, 'MM')}월 손익`],
      datasets: [
        {
          label: '월별손익',
          data: [
            salesTotals, // 매출
            purchaseTotals, // 매입
            cardSalesTotal, // 신용카드매출
            cardPurchaseTotal, // 신용카드 매입
            cashReceiptsSalesTotal, // 현금영수증 매출
            cashReceiptsPurchaseTotal,// 현금영수증 매입
            salaryHistoriesTotal, // 인건비
            monthlyProfitLossTotal // 손익
          ],
          backgroundColor: [
            '#FF5C6D',
            '#4DDDBA',
            '#FF5C6D',
            '#4DDDBA',
            '#FF5C6D',
            '#4DDDBA',
            '#FFB033',
            monthlyProfitLossTotal >= 0 ? '#21D4A9' : '#FF5C6D',
          ],
          borderColor: [
            '#FF5C6D',
            '#4DDDBA',
            '#FF5C6D',
            '#4DDDBA',
            '#FF5C6D',
            '#4DDDBA',
            '#FFB033',
            monthlyProfitLossTotal >= 0 ? '#21D4A9' : '#FF5C6D',
          ],
          borderWidth: 1,
        },
      ],
    })

    setOptions({
      tooltips: {
        callbacks: {
          title: function (tooltipItem, data) {
            return tooltipItem[0].yLabel
          },
          label: function ({ datasetIndex, index, label: totalLabel }, data) {
            const target = data.datasets[datasetIndex]
            return `${comma(target.data[index])}천원`
          }
        }
      },
      isStacked: true,
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            display: true,
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
          },
        ],
        xAxes: [
          {
            id: 'A',
            type: 'linear',
            position: 'left',
            ticks: {
              callback: function (value, index, values) {
                return `${comma(value)}`
              },
            },
          },
        ],
      },
      plugins: {
        datalabels: {
          display: false
        },
      },
      maintainAspectRatio: false
    })
    setIsLoading(false)
  }

  return <div className="monthly-profilt-loss-chart">
    {isLoading ?
      <Loading color={"#5C6DFF"} /> :

      <>
        <CardHeader className="border-bottom-none">
          <CardTitle>
            월별 손익
          </CardTitle>
          <CardUnit>
            <div className="weekly-date-wrap">
              <button className="weekly-button pre" onClick={getPreMonth}>
                <span className="pre" />
              </button>
              <div className="weekly-date">{dateToViewFormat(monthDate.from, 'YYYY.MM')}</div>
              <button className="weekly-button next" onClick={getNextMonth}>
                <span className="next" />
              </button>
            </div>
          </CardUnit>
        </CardHeader>
        <div className="tab-list-wrap">
          <ul className="tab-list">
            {tabList.map((tab, idx) => (
              <li
                key={idx}
                className={classnames("tab-item", {
                  active: activeTab === idx,
                })}
              >
                <a onClick={() => tab.action(idx)}>{tab.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="seles-chart-box pt-32">
          {
            isEmpty(data) ? <NoData /> :
              <HorizontalBar
                data={data}
                options={options}
              />
          }
        </div>
      </>}
  </div>
}

export default MonthlyProfitLossChart